module.exports = __webpack_public_path__ + "static/img/max_pictgrid18_960x858.dcd9bd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/max_pictgrid18_960x858.jpg
// module id = OPT4
// module chunks = 0